<template>
	<div class="tablet-find-another-product" :id="isTabletView ? 'tour-step1' : 'tour-step-alt'">
		<div class="button-wrap">
			<md-button @click="tourActive ? '#' : $emit('seeAllProducts')" data-test="see-all-products">
				<span class="text-find-another-product"> find another product </span>
			</md-button>
			<p class="text-alternatives-available">
				<span> + {{ productsCount }} </span>
				<span> alternatives available </span>
			</p>
		</div>
	</div>
</template>
<script>
export default {
	name: 'ProductBtnTablet',
	props: {
		productsCount: {
			type: Number,
		},
		tourActive: {
			type: Boolean,
			default: false
		},
		isTabletView: {
			type: Boolean,
			default: false
		}
	},
};
</script>
<style lang="scss">
.tablet-find-another-product {
	@media only screen and (min-width: $mobile+1) and (max-width: $tablet) {
		display: block;
	}
	display: none;
	width: 100%;
	height: auto;
	background-color: white;
	text-align: center;
	padding: 38px 0px 38px 0px;
	border-top: 1px solid $color-extra-light-blue;

	.text-find-another-product {
		text-transform: uppercase;
		font-family: Futura W01 Bold;
		font-style: normal;
		font-size: 16px;
		font-weight: 700;
		color: $color-blue;
	}
	.text-alternatives-available {
		font-size: 13px;
		span:nth-child(1) {
			color: $color-blue;
		}
	}
}
</style>
